import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';
import { vuetifyOptions } from './vuetify-options';

Vue.use(Vuetify);

export default new Vuetify(vuetifyOptions);
